import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
// import logger from 'redux-logger';
import { CookiesProvider } from 'react-cookie';
import { I18nextProvider } from 'react-i18next';
import i18n from './utils/i18n';
import App from './containers/App';
// import reportWebVitals from './utils/reportWebVitals';
import { BASENAME } from './utils/constants/general';
import rootReducer from './redux/reducers';
import './index.scss';
import '@fontsource/inter';
import '@fontsource/roboto';
import 'sanitize.css';
import { ThemeContextProvider } from '../src/context/ThemeContextProvider';

const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware => getDefaultMiddleware().concat(thunkMiddleware /* , logger*/),
	devTools: process.env.NODE_ENV !== 'production'
});

ReactDOM.render(
	<React.StrictMode>
		<CookiesProvider>
			<ThemeContextProvider>
				<Provider store={store}>
					<BrowserRouter basename={BASENAME}>
						<I18nextProvider i18n={i18n}>
							<App />
						</I18nextProvider>
					</BrowserRouter>
				</Provider>
			</ThemeContextProvider>
		</CookiesProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
